<script setup>
import { computed, ref } from 'vue'
import { t } from '@/i18n'
import { mediaTypeRef } from '@/model/media'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

const testiUsersItemsToShow = computed(()=> {
  let _val = mediaTypeRef.value
  let _res = 1
  if(_val == '2xl' || _val == 'xl') {
    _res = 3
  }else if( _val == 'lg' || _val == 'md') {
    _res = 2
  }else {
    _res = 1
  }
  return _res
})

let testiUsersListRef = ref([
    {name: 'Ancuta Madalina',post: t('快乐的客户'),avatar: require('@/assets/img/t-Ancuta Madalina.jpg'), tips: t('评论1')},
    {name: 'Natalie',post: t('快乐的客户'),avatar: require('@/assets/img/t-Natalie.jpg'), tips: t('评论2')},
    {name: 'Vjaceslavs Sokolovs',post: t('快乐的客户'),avatar: require('@/assets/img/t-Vjaceslavs Sokolovs.jpg'), tips: t('评论3')},
    {name: 'Matthew',post: t('快乐的酒店老板'),avatar: require('@/assets/img/t-Matthew.jpg'), tips: t('评论4')},
])

const testiIndex = ref(0)
function testiSlideEnd(e) {
  testiIndex.value = e.currentSlideIndex
}
</script>

<template>
    <section class="px-4 py-20 text-default text-sm">
        <div class="w-full px-8 mb-12 text-center relative">
        <div class="flex items-end justify-center">
            <IconStar class="w-4 h-4 text-gray-light" />
            <IconStar class="w-5 h-5 text-third" />
            <IconStar class="w-4 h-4 text-gray-light" />
        </div>
        <h3 class="mt-3 text-2xl text-theme font-bold font-mont">{{t('客户评价')}}</h3>
        <em class="w-12 h-1 mt-3 mx-auto bg-minor rounded-full block"></em>
        <p class="mt-3 text-xs text-gray-default"><b>{{t('查看我们用户的真实评价。')}}</b></p>
        </div>
        <Carousel id="testi-users" @slide-end="testiSlideEnd" :items-to-show="testiUsersItemsToShow" :wrap-around="true" snapAlign="start">
            <Slide v-for="(item,index) in testiUsersListRef" :key="index">
                <div class="w-full md:px-3 pt-12">
                    <div :class="index == testiIndex ? 'bg-minor/20' : 'border border-default bg-default'" class="w-full py-8 px-16 text-default text-left rounded-md relative transition-all duration-200">
                        <em :class="index == testiIndex ? 'text-minor' : 'text-gray-light'" class="absolute top-4 left-4">
                            <svg class="w-10 h-10 opacity-50" fill="currentCOlor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <path d="M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"/>
                            </svg>
                        </em>
                        <em :class="index == testiIndex ? 'text-minor' : 'text-gray-light'" class="absolute bottom-4 right-4">
                            <svg class="w-10 h-10 opacity-50" fill="currentCOlor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <path d="M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"/>
                            </svg>
                        </em>
                        <div :class="index == testiIndex ? 'scale-100' : 'scale-75 opacity-70'" class="w-24 h-24 p-2 bg-white rounded-full border border-default absolute left-16 -top-10 duration-200 transition-all">
                            <img :src="item.avatar" class="w-full h-full rounded-full object-cover">
                        </div>
                        <div class="w-full mb-8 flex items-center justify-end">
                            <IconStar class="w-4 h-4 mx-0.5 text-third" />
                            <IconStar class="w-4 h-4 mx-0.5 text-third" />
                            <IconStar class="w-4 h-4 mx-0.5 text-third" />
                            <IconStar class="w-4 h-4 mx-0.5 text-third" />
                            <IconStar class="w-4 h-4 mx-0.5 text-third" />
                        </div>
                        <h3 class="mb-3 text-xs font-bold">
                            <span>{{item.name}}</span>
                            <span class="mx-1 inline-block">-</span>
                            <span class="text-gray-default">{{item.post}}</span>
                        </h3>
                        <p class="text-sm text-gray-default/80 italic font-serif">“{{item.tips}}”</p>
                    </div>
                </div>
            </Slide>

            <template #addons>
                <Navigation />
                <Pagination />
            </template>
        </Carousel>
    </section>
</template>